import { Outlet } from "react-router-dom";

export function OrgSettingsLayout() {
  return (
    <div className="page">
      <Outlet />
    </div>
  );
}
